module.exports = __webpack_public_path__ + "static/media/bfile-retirement.2e865e9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-retirement.svg
// module id = 3105
// module chunks = 0